import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Button } from 'antd'
import { InfoCircleFilled } from '@ant-design/icons'
import './style.css'

export default class index extends Component {
  state = {
    isShowPop: false,
    clubName: sessionStorage.getItem('club_name'),
    showCancel: this.props.showCancel || true,
    okText: this.props.okText || '是',
    cancelText: this.props.cancelText || '否',
    disabled: this.props.disabled || false,
  }

  togglePop = (e) => {
    e.persist()
    if (this.state.disabled) {
      return
    }
    // const { isShowPop } = this.state
    // this.setState({
    //   isShowPop: !isShowPop,
    // })

    const { clientX, clientY } = e

    const popdiv = document.createElement('div')
    popdiv.id = 'popdiv'
    popdiv.onclick = (e) => {
      this.closePop(popdiv)
    }
    document.body.appendChild(popdiv)

    const { isShowPop, clubName, showCancel, okText, cancelText } = this.state

    const vdom = (
      <div
        className="remake_pop_box"
        style={{ left: clientX - 110, top: clientY - 170 }}
        onClick={(e) => {
          e.stopPropagation()
          console.log('yeah')
        }}
      >
        <div className="remake_pop_club_name">{clubName}</div>

        <div className="remake_pop_title">
          <InfoCircleFilled style={{ color: '#faad14', marginRight: '8px' }} />
          <span>{this.props.title}</span>
        </div>

        <div className="remake_pop_btn_box">
          {showCancel && (
            <Button
              size="small"
              onClick={() => {
                this.closePop(popdiv)
              }}
            >
              {cancelText}
            </Button>
          )}
          <Button
            size="small"
            type="primary"
            className="remake_pop_confirm_btn"
            onClick={this.popConfirm}
          >
            {okText}
          </Button>
        </div>
        <div className="remake_pop_arrow"></div>
      </div>
    )

    ReactDOM.render(vdom, document.getElementById('popdiv'))
  }

  closePop = (dom) => {
    // if (!this.props.onCancel) {
    //   this.setState({
    //     isShowPop: false,
    //   })
    // } else {
    //   this.props.onCancel()
    // }
    document.body.removeChild(dom)
  }

  popConfirm = (e) => {
    e.stopPropagation()
    if (!this.props.onConfirm) {
      this.setState({
        isShowPop: false,
      })
    } else {
      this.props.onConfirm()
      this.setState({
        isShowPop: false,
      })
    }
  }

  render() {
    return (
      <div className="remake_pop_slot" onClick={this.togglePop}>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Popconfirm/Popconfirm2.js